import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
import { focus } from "../constants/colors";

/**
 * Apply this to any element that has a focus ring created with a ::before pseudoelement.
 * {@see createFocusRing} for more details.
 * TODO move this to createFocusRingStyles
 */
export var FOCUS_USING_BEFORE_CLASS_NAME = "lodestar--focus-using-before";

/**
 * Apply this to any element that has a focus ring created with a real
 * DOM element (as opposed to a ::before pseudoelement).
 * {@see createFocusRing} for more details.
 * TODO move this to createFocusRingStyles
 */
export var FOCUS_USING_ELEMENT_CLASS_NAME = "lodestar--focus-using-element";
var focusRingTheme = themed({
  color: {
    "lodestar-light": focus,
    oldestar: "#0073ec",
    "ursa-light": color("focus-indicator--border-primary")
  }
});

/**
 * @deprecated please use createFocusRingStyles instead.
 */
export var getFocusRingStyles = function getFocusRingStyles(_ref) {
  var color = _ref.colorOverride,
    theme = _ref.theme,
    offset = _ref.offset,
    borderRadius = _ref.radius,
    _ref$includeFocusPseu = _ref.includeFocusPseudoClass,
    includeFocusPseudoClass = _ref$includeFocusPseu === void 0 ? false : _ref$includeFocusPseu,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? 2 : _ref$borderWidth,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? "relative" : _ref$position,
    _ref$pseudoElement = _ref.pseudoElement,
    pseudoElement = _ref$pseudoElement === void 0 ? "before" : _ref$pseudoElement,
    _ref$focusSelector = _ref.focusSelector,
    focusSelector = _ref$focusSelector === void 0 ? "focus" : _ref$focusSelector;
  return "\n    & {\n        position: ".concat(position, ";\n        outline: none;\n    }\n\n    &:").concat(focusSelector, " {\n        outline: none;\n    }\n\n    &").concat(includeFocusPseudoClass ? ":".concat(focusSelector) : "", "::").concat(pseudoElement, " {\n        content: \"\";\n        display: block;\n        position: absolute;\n        top: -").concat(offset, "px;\n        right: -").concat(offset, "px;\n        bottom: -").concat(offset, "px;\n        left: -").concat(offset, "px;\n        border: ").concat(borderWidth, "px solid ").concat(color || focusRingTheme.color(theme), ";\n        border-radius: ").concat(typeof borderRadius === "string" ? borderRadius : "".concat(borderRadius, "px"), ";\n        pointer-events: none;\n    }\n");
};
//# sourceMappingURL=focusRing.js.map